import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { Translate } from 'react-localize-redux';

// Store
import AppState from '@webapp/store/state';
import { blockEditor } from '@webapp/store/release/selectors';
import {
  ChangeReleaseInputField,
  UpdateField,
} from '@webapp/store/release/action-creators';

// Components
import InputField from '@components/form/input';

interface UPCCodeCtrlProps {
  className?: string;
  code: string;
  updateCode: (code: string) => ChangeReleaseInputField<'UPCEAN'>;
  updateUpceanField: (code: string) => UpdateField<'UPCEAN'>;
}

interface StoreProps {
  isPreviousRelease: boolean;
  isPublished: boolean;
}

const mapStateToProps = (state: AppState) => ({
  code: state.release.release?.UPCEAN || '',
  isPreviousRelease: state.release.release?.releaseHistory === 'previous',
  isPublished:
    blockEditor(state) ||
    state.release.release?.isPublished ||
    state.release.release?.status === 'taken-down' ||
    state.release.release?.status === 'pending-processing',
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  updateCode: (code: string) =>
    dispatch(new ChangeReleaseInputField<'UPCEAN'>('UPCEAN', code)),
  updateUpceanField: (code: string) =>
    dispatch(new UpdateField<'UPCEAN'>('UPCEAN', code, undefined, true)),
});

export const UPCCodeCtrl: React.FC<UPCCodeCtrlProps & StoreProps> = ({
  code,
  updateCode,
  updateUpceanField,
  ...props
}) => {
  const [customCode, setCustomCode] = React.useState(code || '');

  React.useEffect(() => {
    setCustomCode(code);
  }, [code]);

  React.useEffect(() => {
    const setUPC = () => {
      updateCode(customCode);
      updateUpceanField(customCode);
    };

    const timer = setTimeout(() => {
      setUPC();
    }, 800);

    return () => clearTimeout(timer);
  }, [customCode, updateCode, updateUpceanField]);

  const handleValidateUPC = (value: string) => {
    setCustomCode(value);
  };

  return (
    <div className={props.className}>
      <InputField
        label={<Translate id="RELEASE.DATES_STORES.UPC.INPUT.LABEL" />}
        value={customCode}
        onChange={(value) => handleValidateUPC(value)}
        locked={props.isPublished}
      />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UPCCodeCtrl);
